module.exports = __webpack_public_path__ + "static/Call-centre-guy-33a8636a86d1589c823d138464a288bd.jpg";